import ModalBody from "../../../core/Modal/ModalBody/ModalBody";
import Filter from "../Filter/CashFilter/Filter";

function FilterMobile() {
    return <ModalBody>
        <Filter/>
    </ModalBody>
}

export default FilterMobile